import tileLayers from './tileLayers';
import rasterLayers from './rasterLayers';
import geojsonLayers from './geojsonLayers';
import csvLayers from './csvLayers';
import vectorGridLayers from './vectorGridLayers';

export default [
  ...tileLayers,
  ...rasterLayers,
  ...geojsonLayers,
  ...csvLayers,
  ...vectorGridLayers
];
